/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DatabaseTask } from "./DatabaseTask";
export const GetDatabaseResponse = core.serialization.object({
    task: DatabaseTask,
});
